/**
 * Asks inline before the editor's unsaved text is dropped (a list click,
 * `+ New` or Close while it has changes), never with `window.confirm`.
 * Discard takes focus when it shows, so a keyboard or phone user lands on
 * the question; Keep editing leaves the editor as it was.
 */

import { useEffect, useRef, type ReactElement } from 'react';
import type { PendingDiscard } from '../hooks/useProjectPane';

export function DiscardPrompt({ discard }: { discard: PendingDiscard }): ReactElement {
  const button = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    button.current?.focus();
  }, []);
  const what = discard.name === null ? 'the new definition' : discard.name;
  return (
    <div className="def-actions__confirm project-page__discard" role="group" aria-label="Unsaved changes">
      <span>Discard your changes to {what}?</span>
      <button
        type="button"
        ref={button}
        className="secondary-button secondary-button--danger"
        onClick={discard.confirm}
      >
        Discard
      </button>
      <button type="button" className="secondary-button" onClick={discard.cancel}>
        Keep editing
      </button>
    </div>
  );
}
